import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Space } from 'antd'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

const DemandsButtons = ({
	id,
	onOpenModal,
	loading,
	hasResponsible,
	hasWorkflow = false,
}) => {
	const user = useSelector(({ session }) => session)
	const history = useHistory()
	const hasEditPermission = ['legal', 'admin'].includes(user?.perfil)
	const isLegal = user?.perfil === 'legal'
	const isAdmin = user?.perfil === 'admin'

	const handleChat = () => {
		history.push(`/demands/${id}/chat`)
	}

	function handleEditDemand() {
		history.push(`/demands/${id}/edit`)
	}

	return (
		<div className={styles.buttonsContainer}>
			<Space>
				{hasEditPermission && (
					<>
						{!hasWorkflow && (isLegal || isAdmin) && (
							<Button
								type="outlined"
								danger
								onClick={() => onOpenModal('cancel')}
								disabled={loading}>
								Cancelar
							</Button>
						)}
						{!hasWorkflow && <Button onClick={handleEditDemand}>Editar</Button>}
						{isLegal && !hasResponsible && (
							<Button onClick={() => onOpenModal('set-responsible')}>
								Atribuir a mim
							</Button>
						)}
						{isAdmin && (
							<Button onClick={() => onOpenModal('set-responsible')}>
								Atribuir responsável
							</Button>
						)}
						{!hasWorkflow && (isLegal || isAdmin) && (
							<Button onClick={() => onOpenModal('finish')} disabled={loading}>
								Concluir
							</Button>
						)}
					</>
				)}
				{/* <Button type="primary">Enviar notificação</Button> */}
				<Button onClick={handleChat} type="primary">
					Chat
				</Button>
			</Space>
		</div>
	)
}

DemandsButtons.propTypes = {
	id: PropTypes.string,
	onOpenModal: PropTypes.func,
	loading: PropTypes.bool,
	hasResponsible: PropTypes.bool,
	hasWorkflow: PropTypes.bool,
}

export default DemandsButtons
